const STEPS = [
  "Sila muat turun borang di bawah dan isi semua ruangan dengan lengkap.",
  "Dapatkan tandatangan daripada Ketua Kampung/Penghulu.",
  "Hantar borang yang telah lengkap diisi dan ditandatangani ke alamat berikut:",
];

const statusLabelMap: Record<string, string> = {
  pending: "Sedang Diproses",
  approve: "Lulus",
  rejected: "Ditolak",
  unknown: "-",
};

const statusThemeMap: Record<string, { headerBg: string; text: string }> = {
  pending: {
    headerBg: "#FECD39",
    text: "#272728",
  },
  approve: {
    headerBg: "#1F993B",
    text: "#FFFFFF",
  },
  rejected: {
    headerBg: "#C00",
    text: "#FFFFFF",
  },
  unknown: {
    headerBg: "#F5F5F5",
    text: "#272728",
  },
};

const normalizeStatus = (value?: string) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();

  if (normalized === "pending") return "pending";
  if (normalized === "approve") return "approve";
  if (normalized === "rejected") return "rejected";

  return "unknown";
};

export { STEPS, statusLabelMap, statusThemeMap, normalizeStatus };
